import Vue from 'vue';
import Router from 'vue-router';
import Base from './views/layouts/Base';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: Base,
      children: [
        {
          path: "/",
          component: Home,
          name: "home"
        }
      ]
    },
    {
      path: '/login', redirect: '/'
    }
  ]
});
